import { Pagination, Tag } from 'antd';
import { parseAsInteger, useQueryState } from 'nuqs';
import { QData } from '../../types/basic-type-list';



type MyPaginationProps = {
  qData: QData;
  total: number;
  DEFAULT_NUQS_CONFIG: object;
  onChange?: (newQData: QData) => void;
};

export default function MyPagination(props: MyPaginationProps) {
  const { qData, DEFAULT_NUQS_CONFIG } = props;

  const [page, setPage] = useQueryState(
    'page',
    parseAsInteger.withOptions(DEFAULT_NUQS_CONFIG).withDefault(qData.page ?? 1)
  );

  const [pageLimit, setPageLimit] = useQueryState(
    'limit',
    parseAsInteger.withOptions(DEFAULT_NUQS_CONFIG).withDefault(qData.limit ?? 20)
  );

  const handleChange = (page: number, pp: number) => {
    if (pageLimit !== pp) {
      setPage(1);
      setPageLimit(pp);
      props?.onChange?.({ ...qData, page: 1, limit: pp });
    } else {
      setPage(page);
      setPageLimit(pp);
      props?.onChange?.({ ...qData, page: page, limit: pp });
    }
  };

  const showTotal = () => {
    const start = (page - 1) * pageLimit + 1;
    const end = Math.min(page * pageLimit, props.total);
    return <Tag>{`Showing ${start} - ${end} out of ${props.total}`}</Tag>;
  };

  return (
    <>
      {props.total > 0 ? (
        <Pagination
          total={props.total}
          showTotal={showTotal}
          pageSize={pageLimit}
          current={page}
          onChange={handleChange}
          showSizeChanger={true}
        />
      ) : null}
    </>
  );
}


// import { Select, Tag } from "antd";
// import { parseAsInteger, useQueryState } from "nuqs";
// import { QData } from "../../types/basic-type-list";

// type MyPaginationProps = {
//   qData: QData;
//   total: number;
//   DEFAULT_NUQS_CONFIG: object;
//   onChange?: (newQData: QData) => void;
// };

// export default function MyPagination(props: MyPaginationProps) {
//   const { qData, DEFAULT_NUQS_CONFIG } = props;

//   const [page, setPage] = useQueryState(
//     "page",
//     parseAsInteger.withOptions(DEFAULT_NUQS_CONFIG).withDefault(qData.page ?? 1)
//   );

//   const [pageLimit, setPageLimit] = useQueryState(
//     "limit",
//     parseAsInteger.withOptions(DEFAULT_NUQS_CONFIG).withDefault(qData.limit ?? 20)
//   );

//   const handleSizeChange = (value: number) => {
//     setPage(1);
//     setPageLimit(value);
//     props?.onChange?.({ ...qData, page: 1, limit: value });
//   };

//   return (
//     <>
//       {props.total > 0 ? (
//         <div className="flex justify-end gap-3">
//           <Select
//             value={pageLimit}
//             onChange={handleSizeChange}
//             style={{ width: 100 }}
//             options={[
//               { value: 5, label: "5" },
//               { value: 10, label: "10" },
//               { value: 20, label: "20" },
//               { value: 50, label: "50" },
//             ]}
//           />
//         </div>
//       ) : null}
//     </>
//   );
// }

